module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-24.a4a80fb4.png";